module.exports = __webpack_public_path__ + "img/Abstract-innovative.ce399683.svg";